// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b45ec4f5","239":"9dc367c6","455":"3316667c","977":"7ec36f8d"}[chunkId] + ".chunk.js";
};